export const VERTICAL_LABELS = [
  { top: "СЗ 2", down: "Ю 3" },
  { top: "СЗ 3", down: "Ю 2" },
  { top: "С 1", down: "Ю 1" },
  { top: "С 2", down: "ЮВ 3" },
  { top: "С 3", down: "ЮИ 2" },
] as const;

export const HORIZONTAL_LABEL = [
  { left: "З 3", right: "СВ 2" },
  { left: "З 2", right: "СВ 3" },
  { left: "З 1", right: "В 1" },
  { left: "ЮЗ 3", right: "В 2" },
  { left: "ЮЗ 2", right: "В 3" },
] as const;

export const CORNER_LABEL = {
  topLeft: "СЗ 1",
  topRight: "СВ 1",
  bottomLeft: "ЮЗ 1",
  bottomRight: "ЮВ 1",
} as const;
